import React, { FC } from 'react';
import { Popup } from '@components/atoms/Popup';
import { Typography, TypographyTagVariants } from '@components/atoms/Typography';
import { Button, ButtonMode } from '@components/atoms/Button';
import styles from './PopupConfirm.module.css';

export interface PopupConfirmProps {
    id?: string;
    question: string;
    confirmation: string;
    cancelButtonText: string;
    confirmButtonText: string;
    onClickCancel: () => void;
    onClickConfirm: () => void;
    show: boolean;
    onHide: () => void;
}

export const PopupConfirm: FC<PopupConfirmProps> = ({
    id,
    question,
    confirmation,
    cancelButtonText,
    confirmButtonText,
    onClickCancel,
    onClickConfirm,
    show,
    onHide,
}) => {
    return (
        <Popup id={id || undefined} show={show} onHide={onHide} desktopWidth="400px">
            <div className={`${styles.content} d-flex flex-column gap-3`}>
                <Typography tagVariant={TypographyTagVariants.p} classes="mb-0" fontSize="20" fontWeight="900">
                    {question}
                </Typography>
                <Typography tagVariant={TypographyTagVariants.p} classes="mb-0" fontSize="16">
                    {confirmation}
                </Typography>
                <div className="d-flex gap-4 mt-3">
                    <div>
                        <Button label={cancelButtonText} mode={ButtonMode.danger} classes="w-100" onClick={onClickCancel} />
                    </div>
                    <div>
                        <Button label={confirmButtonText} mode={ButtonMode.primary} classes="w-100" onClick={onClickConfirm} />
                    </div>
                </div>
            </div>
        </Popup>
    );
};
